import { IUser } from './user'

export enum BannerStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	DELETED = 'DELETED',
}

export interface IBanner {
	_id: string
	image: string
	title: string
	redirectLink: string
	retail: IBannerRetail[]
	status: BannerStatus
	createdBy: Pick<IUser, '_id' | 'name'>
	createdAt: string
	updatedAt: string
}

export interface IBannerRetail {
	retailId: string
	order: number
}

export interface IBannerOrder {
	_id: string
	order: number
	retailId: string
}
